import React, { useState } from "react";
import { Button, Input, MenuSelect } from "../components/Form";
import { BiLogInCircle } from "react-icons/bi";

import { useAppDispatch, useAppSelector } from "../store";
import { useNavigate } from "react-router-dom";
import { register } from "../features";
import { toast } from "react-toastify";

function SignUp() {

	const userData = useAppSelector((state) => state.userData);
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [language, setLanguage] = useState("Language");

	const handleRegistration = (e) => {
		e.preventDefault();
		if (userData.loading) return;
		if (
			email === '' ||
			password === '' ||
			firstName === '' ||
			lastName === ''
		) {
			toast.error('Please fill in all fields');
			return;
		}

		if (password.length < 6) {
			toast.error('Password must be at least 6 characters long');
			return;
		}

		dispatch(register({ email, password, firstName, lastName }));
	};

	React.useEffect(() => {
		if (userData.isAuthenticated) {
			navigate('/');
		}
	}, [userData.isAuthenticated, navigate]);

	return (
		<div className="flex flex-col w-full h-screen items-center justify-center bg-dry">
			<form className="grid grid-cols-12 w-auto min-w-96 min-h-[90vh] shadow-2xl mx-auto bg-white" onSubmit={handleRegistration}>
				<div className="flex flex-col items-center justify-center col-span-5 bg-subMain p-8 ">
					<img src="/images/logo.png" alt="logo" className="w-48 h-16 object-contain" />
					<MenuSelect
						className={"w-[100%] text-center mt-1 p-2 border rounded-lg"}
						datas={[
							{ title: "English", onClick: () => setLanguage("English") },
							{ title: "French", onClick: () => setLanguage("French") },
							{ title: "Spanish", onClick: () => setLanguage("Spanish") },
							{ title: "Portuguese", onClick: () => setLanguage("Portuguese") }
						]}>
						<div className="text-white">{language}</div>
					</MenuSelect>
				</div>
				<div className="grid col-span-7 p-8">
					<div className="flex flex-col w-full mb-3">
						<div className="text-xl">Register</div>
						<Input className={"mb-0"} type="text" color placeholder={"First Name"} name={"firstName"} value={firstName} onChange={(e) => setFirstName(e.target.value)} />
						<Input className={"mb-0"} type="text" color placeholder={"Last Name"} name={"lastName"} value={lastName} onChange={(e) => setLastName(e.target.value)} />
						<Input className={"mb-0"} type="email" color placeholder={"Email"} name={"email"} value={email} onChange={(e) => setEmail(e.target.value)} />
						<Input className={"mb-0"} type="password" color placeholder={"Password"} name={"password"} value={password} onChange={(e) => setPassword(e.target.value)} />
					</div>
					{userData.loading ?
						<div className="flex justify-center items-center">
							<svg
								width='20'
								height='20'
								fill='currentColor'
								className='animate-spin'
								viewBox='0 0 1792 1792'
								xmlns='http://www.w3.org/2000/svg'
							>
								<path d='M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z'></path>
							</svg>
						</div>
						:
						<Button type="submit" label="Register" Icon={BiLogInCircle} />
					}
					<div className="w-full text-center mt-4 mb-1">or register with:</div>
					<Button
						className={"w-full !bg-red-500/90  !text-white !py-1"}
						label={" GOOGLE"}
						Icon={() => <p className="text-xl">G</p>}
					/>
					<Button
						className={"w-full bg-transparent !text-subMain"}
						label={"GO TO LOGIN"}
						onClick={() => navigate("/login")}
					/>
				</div>
			</form >
		</div >
	);
}

export default SignUp;
